module.exports = __webpack_public_path__ + "img/8yotea.2d3a3468.svg";